import { memo, useRef } from "react";

/**
 * Efecto «luz ambiental»: el vídeo se muestra nítido en su proporción 16:9
 * original (sin recortar ni ampliar de más) y detrás una copia desenfocada
 * rellena toda la pantalla con sus mismos tonos.
 */
const FullscreenIntroVideo = memo(function FullscreenIntroVideo({
  src,
  onPlay,
}: {
  src: string;
  onPlay?: () => void;
}) {
  const bgRef = useRef<HTMLVideoElement>(null);
  const common = {
    src,
    autoPlay: true,
    muted: true,
    playsInline: true,
    preload: "auto" as const,
    draggable: false,
    "aria-hidden": true,
    onContextMenu: (e: React.MouseEvent) => e.preventDefault(),
    controlsList: "nodownload nofullscreen noremoteplayback",
    disablePictureInPicture: true,
    disableRemotePlayback: true,
  };
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none select-none">
      <video
        {...common}
        ref={bgRef}
        className="absolute inset-0 w-full h-full object-cover scale-110"
        style={{ filter: "blur(40px) brightness(0.8) saturate(1.2)" }}
        onEnded={(e) => e.currentTarget.pause()}
      />
    </div>
  );
});

/** Vídeo nítido a tamaño original, para colocar dentro del flujo de la página. */
export const SharpIntroVideo = memo(function SharpIntroVideo({
  src,
  onPlay,
  className = "w-96 md:w-[28rem]",
}: {
  src: string;
  onPlay?: () => void;
  className?: string;
}) {
  return (
    <div
      className={`${className} pointer-events-none select-none`}
      style={{
        WebkitMaskImage: "radial-gradient(ellipse at center, black 70%, transparent 100%)",
        maskImage: "radial-gradient(ellipse at center, black 70%, transparent 100%)",
      }}
    >
      <video
        src={src}
        autoPlay
        muted
        playsInline
        preload="auto"
        draggable={false}
        className="w-full object-contain"
        onPlay={onPlay}
        onEnded={(e) => e.currentTarget.pause()}
        onContextMenu={(e) => e.preventDefault()}
        controlsList="nodownload nofullscreen noremoteplayback"
        disablePictureInPicture
        disableRemotePlayback
      />
    </div>
  );
});

export default FullscreenIntroVideo;
